import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../utils/api"; // ✅ FIXED IMPORT

const DashboardRouter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        // ✅ Get fresh user from backend
        const res = await API.get("/dashboard");
        const user = res.data?.user;

        // ❌ No user found → login
        if (!user) {
          navigate("/login");
          return;
        }

        // ✅ Sync localStorage so other dashboards still work (VERY IMPORTANT for your current system)
        localStorage.setItem("user", JSON.stringify(user));

        // 🔒 Not subscribed → demo dashboard
        if (!user.subscriptionActive) {
          navigate("/dashboard-demo");
          return;
        }

        const plan = user.plan?.toLowerCase();

        // 🧭 Route based on plan
        if (plan === "basic") {
          navigate("/dashboard-basic");
          return;
        }

        if (plan === "premium") {
          navigate("/dashboard-premium");
          return;
        }

        if (plan === "elite") {
          navigate("/dashboard-elite");
          return;
        }

        // 🧯 fallback
        navigate("/dashboard-demo");

      } catch (err) {
        console.error("DashboardRouter error:", err);
        navigate("/login");
      }
    };

    fetchUser();
  }, [navigate]);

  return (
    <div className="text-white text-center mt-20">
      Loading Dashboard...
    </div>
  );
};

export default DashboardRouter;
